export * from './square-vent.component';